import { Component, inject } from '@angular/core';
import { MDIconComponent } from '@melodic-ui/components';
import { ChatStateService } from '@lb/state/chat-state.service';

@Component({
	selector: 'lb-chat-toggle-button',
	standalone: true,
	imports: [MDIconComponent],
	templateUrl: './chat-toggle-button.component.html',
	styleUrl: './chat-toggle-button.component.scss'
})
export class ChatToggleButtonComponent {
	private _chatStateService = inject(ChatStateService);

	isOpen = this._chatStateService.isSlideoutOpen;

	toggle(): void {
		this._chatStateService.toggleSlideout();
	}
}
